import { add, listen, qs, remove } from "@fluorescent/dom";

import { emit } from "@/glow/events";
import ProductForm from "@/lib/productForm";
import selectors from "@/lib/selectors";
import {
  getProduct,
  updateBuyButton,
  updatePrices,
  updateUnitPrices,
  updateQuickShopMedia,
} from "@/lib/product";
import { cart } from "@/glow";

const { product: selector } = selectors;

export default function ProductTitle(node) {
  const imageWrapper = qs(".product-tile__image-wrapper", node);
  const quickShop = qs(".quick-shop", node);
  const quickShopButton = qs(".product-tile__quick-shop-button", node);
  const quantityError = qs("[data-quantity-error]", node);
  let productFeaturedImage = null;
  const events = [];

  const callObject = {
    container: quickShop,
  };

  if (imageWrapper) {
    initImageHover();
  }

  // A callback method that is fired whenever the user changes the value of an option input.
  function onOptionChange(event) {
    const { variant } = event.dataset;

    if (!variant) {
      updateBuyButton.call(callObject, { available: false });
      return;
    }

    // We need to set the id input manually so the Dynamic Checkout Button works
    const selectedVariantOpt = qs(
      `${selector.variantSelect} ${selector.optionById(variant.id)}`,
      quickShop
    );
    selectedVariantOpt.selected = true;

    if (variant.featured_media) {
      updateQuickShopMedia.call(callObject, variant.featured_image.src);
    } else {
      updateQuickShopMedia.call(callObject, productFeaturedImage);
    }
    updatePrices.call(callObject, variant);
    updateBuyButton.call(callObject, variant);
    updateUnitPrices(quickShop, variant);
  }

  function onFormSubmit(evt) {
    evt.preventDefault();

    const button = qs(selector.addButton, quickShop);
    add(button, "bttn--loading");

    add(quantityError, "hidden");

    cart
      .addItem(evt.target)
      .then(() => {
        remove(button, "bttn--loading");
      })
      .catch(() => {
        remove(quantityError, "hidden");
        remove(button, "bttn--loading");
      });
  }

  function handleOver(e) {
    const parent = e.target.closest(".product-tile");
    const first = qs(".first", parent);
    const second = qs(".not-first", parent);

    if (!second) return;

    add(first, "hidden");
    add(second, "visible");
  }

  function handleOut(e) {
    const parent = e.target.closest(".product-tile");
    const first = qs(".first", parent);
    const second = qs(".not-first", parent);

    if (!second) return;

    remove(first, "hidden");
    remove(second, "visible");
  }

  function handleQuickShop(e) {
    e.preventDefault();

    const formElement = qs(selector.form, quickShop);
    let productForm = null;
    const { productHandle } = formElement.dataset;

    const productJSON = getProduct(productHandle);

    productJSON(data => {
      productForm = ProductForm(formElement, data, {
        onOptionChange: e => onOptionChange(e),
        onFormSubmit: onFormSubmit,
      });

      productFeaturedImage = data.featured_image;

      const variant = productForm.getVariant();

      if (variant.options.length > 1) {
        updatePrices.call(callObject, variant);
      }

      emit("cart:toggle", state => {
        return {
          cartOpen: !state.cartOpen,
          quickShopProduct: quickShop,
        };
      });
    });
  }

  function initImageHover() {
    events.push(listen(imageWrapper, "mouseover", handleOver));
    events.push(listen(imageWrapper, "mouseout", handleOut));
  }

  if (quickShopButton) {
    events.push(listen(quickShopButton, "click", handleQuickShop));
  }

  const unload = () => {
    events.forEach(unsubscribe => unsubscribe());
  };

  return { unload };
}
